var _DIRECTION_TO_CLASSNA;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
export var MINIMUM_CROP_DIMENSION = 20;
export var CROP_THUMB_NE = 'crop-handle-ne';
export var CROP_THUMB_SE = 'crop-handle-se';
export var CROP_THUMB_SW = 'crop-handle-sw';
export var CROP_THUMB_NW = 'crop-handle-nw';
export var CROP_THUMB_DIRECTIONS = [CROP_THUMB_NE, CROP_THUMB_SE, CROP_THUMB_SW, CROP_THUMB_NW];
export var DIRECTION_TO_CLASSNAME_MAP = (_DIRECTION_TO_CLASSNA = {}, _defineProperty(_DIRECTION_TO_CLASSNA, CROP_THUMB_NE, 'eds-image-cropper__thumb--ne'), _defineProperty(_DIRECTION_TO_CLASSNA, CROP_THUMB_SE, 'eds-image-cropper__thumb--se'), _defineProperty(_DIRECTION_TO_CLASSNA, CROP_THUMB_SW, 'eds-image-cropper__thumb--sw'), _defineProperty(_DIRECTION_TO_CLASSNA, CROP_THUMB_NW, 'eds-image-cropper__thumb--nw'), _DIRECTION_TO_CLASSNA);
export var CROP_MASK_PROP_TYPE = PropTypes.shape({
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired
});